import { useState, useEffect } from 'react';

export function useIntersection(ref: React.RefObject<Element>): boolean {
  const [isInViewOnLoad, setIsInViewOnLoad] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const { top, bottom } = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const inView = bottom > 0 && top < viewportHeight;

    setIsInViewOnLoad(inView);
  }, [ref]);

  return isInViewOnLoad;
}
